import React from 'react';
import { article, publication } from '../data/story';
export function ArticleHeader() {
  return <header className="w-full" data-id="element-3" data-mp="w3mxk8otda1k">
      <div className="flex items-center justify-between gap-4 border-b border-neutral-200 px-5 py-2.5 sm:px-8" data-id="element-4" data-mp="w4ojj87dbgy2">
        <span className="font-ui text-[11px] font-bold uppercase tracking-[0.09em] text-purple-brand sm:text-xs" data-id="element-5" data-mp="i56o49zkh5fq">
          {publication.brand}
        </span>
        <span className="font-ui text-[9px] uppercase tracking-[0.05em] text-neutral-400 sm:text-[10px]" data-id="element-6" data-mp="1arrg9cnv9lkc">
          {publication.tag}
        </span>
      </div>

      <div className="border-b border-neutral-100 px-5 pb-4 pt-5 sm:px-8 sm:pb-5 sm:pt-6" data-id="element-7" data-mp="1fsxdnnsh1x07">
        <p className="font-ui text-[10px] uppercase tracking-[0.15em] text-neutral-400 sm:text-[10.5px]" data-id="element-8" data-mp="110dlfi6v19xj">
          {publication.kicker}
        </p>
        <h1 className="mt-2 max-w-3xl font-article text-[22px] font-bold leading-tight text-purple-deep sm:text-[26px] lg:text-[30px]" data-id="element-9" data-mp="1tpuac5v9u8p0">
          {article.headline}
        </h1>
        <p className="mt-2.5 font-ui text-[11.5px] text-neutral-500" data-id="element-10" data-mp="nkq1c6hfwf2">
          By {article.author}
          <span className="mx-2 text-neutral-300" data-id="element-11" data-mp="3rux8rvn0khx3">|</span>
          {article.updated}
          <span className="mx-2 text-neutral-300" data-id="element-12" data-mp="9g5uroda42kw">|</span>
          {article.readingTime}
        </p>
      </div>
    </header>;
}